import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaCheck } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { showToast } from "../../../../../redux/slices/toastSlice";
import CargoService from "../../../../../services/Cargo";

export default function SupportModal({
    isOpen,
    onClose,
    render

}) {
    const dispatch = useDispatch()
    const [subject, setSubject] = useState("");
    const [description, setDescription] = useState("");
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        let el = document.getElementById("modal-root");
        if (!el) {
            el = document.createElement("div");
            el.id = "modal-root";
            document.body.appendChild(el);
        }
    }, []);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose && onClose();
        };
        if (isOpen) document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [isOpen, onClose]);

    if (typeof document === "undefined") return null;

    const handleSend = async () => {
        if (!subject.trim() || !description.trim()) return;
        setLoading(true)
        try {
            const body =
            {
                "subject": subject,
                "description": description,
                "role": "sell",
            }
            const res = await CargoService.sendTicket(body)
             await render();
             setSubject("");
             setDescription("");
             dispatch(showToast({ message: "تیکت شما با موفقیت ثبت شد", type: "success" }))
             onClose();
      


        } catch (err) {
            console.log(err)
            dispatch(showToast({ message: "خطا در ثبت تیکت", type: "error" }))

        } finally {
            setLoading(false)
        }





    };


    return createPortal(
        <>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        key="overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.18 }}
                        className="fixed inset-0 z-50 px-3 sm:px-5 flex items-center justify-center"
                        aria-modal="true"
                        role="dialog"
                    >
                        <div
                            onClick={onClose}
                            className="absolute inset-0 bg-black/55 backdrop-blur-sm"
                            aria-hidden="true"
                        />

                        <motion.div
                            key="modal"
                            initial={{ opacity: 0, y: 24, scale: 0.98 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 24, scale: 0.98 }}
                            transition={{ duration: 0.28, ease: "easeOut" }}
                            onClick={(e) => e.stopPropagation()}
                            className="relative z-40 w-full max-w-xl bg-white rounded-2xl sm:rounded-3xl shadow-xl px-5 sm:px-10 md:px-16 pt-6 sm:pt-10 pb-10 sm:pb-16 flex flex-col"
                            style={{
                                boxShadow:
                                    "0 10px 30px rgba(2,6,23,0.15), inset 0 1px 0 rgba(255,255,255,0.35)",
                            }}
                        >
                            <div className="mb-4 sm:mb-6">
                                <h3 className="text-base sm:text-lg font-semibold text-gray-700">
                                    تیکت جدید
                                </h3>
                            </div>

                            <form
                                className="flex flex-col gap-4 sm:gap-5"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSend();
                                }}
                            >
                                {/* موضوع */}
                                <div className="flex items-center gap-2">
                                    <label
                                        htmlFor="subject"
                                        className="w-14 sm:w-16 md:w-20 text-gray-700 font-medium text-sm sm:text-base"
                                    >
                                        موضوع
                                    </label>
                                    <input
                                        id="subject"
                                        type="text"
                                        value={subject}
                                        onChange={(e) =>
                                            setSubject(e.target.value)
                                        }
                                        placeholder="مشکل دارم"
                                        className="flex-1 border border-gray-300 rounded-xl p-2.5 sm:p-3 text-gray-700 text-sm sm:text-base focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                    />
                                </div>

                                {/* توضیحات */}
                                <div className="flex items-start gap-2">
                                    <label
                                        htmlFor="description"
                                        className="w-14 sm:w-16 md:w-20 text-gray-700 font-medium text-sm sm:text-base pt-1.5 sm:pt-2"
                                    >
                                        توضیحات
                                    </label>
                                    <textarea
                                        id="description"
                                        value={description}
                                        onChange={(e) =>
                                            setDescription(e.target.value)
                                        }
                                        placeholder="توضیح"
                                        className="flex-1 h-24 sm:h-28 resize-none border border-gray-300 rounded-xl p-2.5 sm:p-3 text-gray-700 text-sm sm:text-base focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                    />
                                </div>


                                <div className="flex gap-2">
                                    <div className="w-14 sm:w-16 md:w-20" />
                                    <div className="flex-1 flex justify-center">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="w-4/5 sm:w-3/5 h-10 sm:h-11 mt-1.5 sm:mt-2 rounded-lg bg-special text-white text-sm sm:text-base hover:bg-blue-900 transition disabled:opacity-50"
                                        >
                                            {loading
                                                ? "در حال ارسال..."
                                                : "ارسال به پشتیبانی"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>


        </>,
        document.getElementById("modal-root") || document.body
    );
}
